module.exports = __webpack_public_path__ + "static/media/homepage-events.9d11438d.svg";